var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-flex"},[_c('div',{staticClass:"modal-flex-inner"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-size",staticStyle:{"width":"1024px","overflow":"hidden"}},[_c('router-view',{attrs:{"isModal":true}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }